import { Theme } from "@mui/material";

export const modalBoxStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "16px",
  boxShadow: 24,
  background: "none",
  width: { xs: "90%", sm: "70%", md: "60%" },
};

export const headerStyles = (theme: Theme) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  background: theme.palette.modalColors.headerColor,
  paddingY: "16px",
  paddingX: "38px",
  borderTopLeftRadius: "16px",
  borderTopRightRadius: "16px",
});

export const contentStyles = (theme: Theme) => ({
  display: "flex",
  gap: "16px",
  flexDirection: "column",
  backgroundColor: theme.palette.modalColors.bgColor,
  padding: "22px",
  borderBottomLeftRadius: "16px",
  borderBottomRightRadius: "16px",
  overflowY: "auto",
  maxHeight: { xs: "80dvh", sm: "80dvh", md: "80dvh" },
});

export const avatarsContainerStyles = {
  display: "flex",
  gap: "16px",
  flexDirection: { xs: "column", sm: "column", md: "row" },
};
